export default [
  { label: '18 or under', value: '18-or-under' },
  { label: '19-30', value: '19-30' },
  { label: '31-40', value: '31-40' },
  { label: '41-50', value: '41-50' },
  { label: '51-60', value: '51-60' },
  { label: '61+', value: '61+' }
]
